import React, { FC } from "react";
import { Select, Text, Box } from "@primer/react";

export interface TemplateSelectPrimerProps {
  templates: string[];
  selectedTemplate: string;
  onChange: (template: string) => void;
}

export const TemplateSelectPrimer: FC<TemplateSelectPrimerProps> = ({
  templates,
  selectedTemplate,
  onChange,
}) => (
  <Box display="flex" alignItems="center" className="template-select-container">
    <Text fontSize={0} className="template-select-label">
      Template 
    </Text>
    <Select
      value={selectedTemplate}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      className="template-select-dropdown"
    >
      {templates.map((template) => (
        <Select.Option key={template} value={template}>
          {template}
        </Select.Option>
      ))}
    </Select>
  </Box>
); 